import React, { Component } from 'react';
import Modal from 'react-modal';
import { MarketCodes } from '../marketCodes';

const NO_TIMEOUT = '';
const ABOUT_TO_TIMEOUT = 'aboutToTimeout';
const SESSION_TIMEOUT = 'sessionTimeout';

const ABOUT_TO_TIMEOUT_VALUE = 1620000;
const SESSION_TIMEOUT_VALUE = 1800000;

const customStyles = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.75)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    zIndex: '2000',
    padding: '1.2rem'
  },
  content: {
    maxWidth: 800,
    width: '70%',
    left: '-1%',
    top: '30%',
    bottom: 0,
    right: 0,
    position: 'relative',
    padding: '1.2rem',
    background: '#ffffff',
    backgroundClip: 'border-box',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,0.25)'
  }
};

class Timeout extends Component {

  state = {
    timeoutStatus: NO_TIMEOUT,
    step: ''
  };

  openModal = () => {
  };

  onCloseModal = () => {
    this.setState({ timeoutStatus: NO_TIMEOUT });
  };

  showModal = () => {
    return this.state.timeoutStatus !== NO_TIMEOUT;
  };

  afterOpenModal = () => {
    window.setTimeout(() => {
      document.getElementById('heading').focus();
    }, 0);
  };

  validStepForTimeout = (step) => {
    const timerSteps = ['miniApp', 'quotes', 'fullApp', 'comboApp', 'interstitial'];
    return timerSteps.includes(step);
  };

  setAppElement = () => {
    let modal = this.props.Modal || Modal;
    modal.setAppElement('#app');
  };

  componentWillMount = () => {
    this.setAppElement();
  };

  componentWillUpdate = () => {
    this.setAppElement();
  };

  componentDidMount = () => {
    this.setState({ step: this.props.step });
    if (this.validStepForTimeout(this.state.step)) {
      this.startTimer();
    }
  };

  componentWillUnmount = () => {
    this.stopTimer();
  };

  componentWillReceiveProps = (newProps) => {
    if (this.validStepForTimeout(newProps.step)) {
      if (!this.sessionTimeoutID) {
        this.startTimer();
      }
    } else {
      this.stopTimer();
    }

    if (this.state.step !== newProps.step) {
      if (this.validStepForTimeout(newProps.step)) {
        this.extendSession();
      }
      this.setState({ step: newProps.step });
    }
  };

  handleSessionAboutToTimeout = () => {
    this.resetSessionAboutToTimeout();
    this.setState({ timeoutStatus: ABOUT_TO_TIMEOUT });
  };

  handleSessionTimeout = () => {
    this.resetSessionTimeout();
    this.props.dispatcher.navigateToLandingPage();
    this.setState({ timeoutStatus: SESSION_TIMEOUT });
    if(this.props.marketCode === MarketCodes.OPEN_MARKET || this.props.marketCode === MarketCodes.LENDING_TREE || this.props.marketCode === MarketCodes.CREDIT_KARMA) {
      this.props.history.push('/apply');
      this.props.dispatcher.applicationDataReset();
    }
  };

  stopTimer = () => {
    if (this.sessionTimeoutID) clearTimeout(this.sessionTimeoutID);
    if (this.sessionAboutToTimeoutID) clearTimeout(this.sessionAboutToTimeoutID);
  };

  isToggleOn = () => {
    if (!window || !window.toggles) return false;
    return window.toggles.sessionTimeoutValues;
  };

  startTimer = () => {
    let aboutToTimeoutValue = ABOUT_TO_TIMEOUT_VALUE;
    let sessionTimeoutValue = SESSION_TIMEOUT_VALUE;
    if(this.props.timeout){
      const { timeout } = this.props.timeout;
      aboutToTimeoutValue = timeout.aboutToTimeoutValue;
      sessionTimeoutValue = timeout.sessionTimeoutValue;
    }else if (this.isToggleOn()) {
      aboutToTimeoutValue = 300000;
      sessionTimeoutValue = 600000;
    }
    this.sessionAboutToTimeoutID = setTimeout(this.handleSessionAboutToTimeout, aboutToTimeoutValue);
    this.sessionTimeoutID = setTimeout(this.handleSessionTimeout, sessionTimeoutValue);
  };

  resetTimer = () => {
    this.resetSessionTimeout();
    this.resetSessionAboutToTimeout();
    this.startTimer();
  };

  resetSessionTimeout = () => {
    this.resetSessionAboutToTimeout();
    clearTimeout(this.sessionTimeoutID);
  };

  resetSessionAboutToTimeout = () => {
    clearTimeout(this.sessionAboutToTimeoutID);
  };

  extendSession = () => {
    this.setState({ timeoutStatus: NO_TIMEOUT });
    this.props.dispatcher.extendSession()
      .then(() => {
        this.resetTimer();
      })
      .catch();
  };

  render() {
    if (!this.state || !this.state.timeoutStatus) return (null);
    if (this.state.timeoutStatus === SESSION_TIMEOUT) {
      return (
        <Modal
          key="sessionTimeout"
          isOpen={this.showModal()}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.onCloseModal}
          shouldCloseOnOverlayClick={false}
          style={customStyles}
          shouldCloseOnEsc={true}
          aria={{
            labelledby: "heading",
            describedby: "description"
          }}
        >
          <div>
            <div className="timeoutImage">
              <img src="/clapply/cyr/session-timeout.svg" alt="Session timeout" className="modal-img session-timeout"/>
            </div>
            <div className="timeoutText">
              <h2 id="heading">Unfortunately, your session has expired due to inactivity.</h2>
              <button className="close" id="closeButton" onClick={this.onCloseModal}>X</button>
              <p id="description">For questions call: 877-437-3342 <br />Thank you for your interest in a Barclays Personal Loan.</p>
            </div>
          </div>
        </Modal>
      );

    } else if (this.state.timeoutStatus === ABOUT_TO_TIMEOUT) {
      return (
        <Modal
          key="aboutToTimeout"
          isOpen={this.showModal()}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.onCloseModal}
          shouldCloseOnOverlayClick={false}
          style={customStyles}
          shouldCloseOnEsc={false}
          aria={{
            labelledby: "heading",
            describedby: "description"
          }}
        >
          <div>
            <div className="timeoutImage">
              <img src="/clapply/cyr/session-timeout.svg" alt="Session Timeout" className="modal-img session-timeout"/>
            </div>
            <div className="timeoutText">
              <h2 id="heading">Your session is about to time out.</h2>
              <p id="description">Please press 'Continue' to complete your application otherwise your application will be lost.</p>
              <button className="btn btn-success btn-extend-session" id="timeoutContinueBtn" type="button"
                onClick={this.extendSession}>Continue
              </button>
            </div>
          </div>
        </Modal>
      );
    } else {
      return (null);
    }
  }
}

export default Timeout;
